export default __webpack_public_path__ + "static/media/freebee1.1d285b01.png";